import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47897888"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Carte Confituur | Grafisch ontwerpstudio | Nazareth-De Pinte", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "canonical",
  href: "https://www.carteconfituur.be/"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "description",
  content: "Carte Confituur is een grafisch ontwerp bureau te Nazareth-De Pinte. Deze one-woman-business levert uniek grafisch ontwerp."
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:title",
  content: "Carte Confituur | Grafisch ontwerpstudio | Nazareth-De Pinte"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:url",
  content: "https://www.carteconfituur.be/"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:description",
  content: "Carte Confituur is een grafisch ontwerp bureau te Nazareth-De Pinte. Deze one-woman-business levert uniek grafisch ontwerp."
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:type",
  content: "website"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:title",
  content: "Carte Confituur | Grafisch ontwerpstudio | Nazareth-De Pinte"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:description",
  content: "Carte Confituur is een grafisch ontwerp bureau te Nazareth-De Pinte. Deze one-woman-business levert uniek grafisch ontwerp."
}, null, -1))
const _hoisted_10 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Landing = _resolveComponent("Landing")!
  const _component_Services = _resolveComponent("Services")!
  const _component_RecentProjects = _resolveComponent("RecentProjects")!
  const _component_NiceWords = _resolveComponent("NiceWords")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_1
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_2
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_3
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_4
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_5
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_6
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_7
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_8
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_9
    ])),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_Landing),
      _createVNode(_component_Services),
      _createVNode(_component_RecentProjects),
      _createVNode(_component_NiceWords)
    ])
  ], 64))
}